import styles from "./AdditionalOptions.module.css";
import share_icon from "../../../Assets/Images/share_icon.png";
import download_icon from "../../../Assets/Images/download_icon.png";
import mail_icon from "../../../Assets/Images/mail_icon.png";
import teams_icon from "../../../Assets/svgs/microsoft-teams-svgrepo-com.svg";
import copy_icon from "../../../Assets/svgs/content_copy.svg";
import visual_icon from "../../../Assets/Images/data-visualization.png";
import auto_visualize from "../../../Assets/svgs/auto_visualize.svg";
import bar_chart from "../../../Assets/Images/bar-chart.png"
import pie_chart from "../../../Assets/Images/pie-chart.png";
import line_chart from "../../../Assets/Images/line-chart.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import SqlDrawer from "./SqlQueryComponent";
import React from "react";
import { Box, Menu, MenuItem, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { callLogEvent } from "../../../Common/Util";
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const AdditionalOptions = ({ msg, refId, questionRefs, handleVisualization, handleSavedChats }: any) => {
  const handlePrint = () => {
    const wrapper = document.createElement("div");
    const clonedRefId = refId.cloneNode(true);
    if (msg.sender !== "summary") {
      const clonedQuestionId = questionRefs.cloneNode(true);
      clonedQuestionId.style.fontSize = "30px";
      clonedQuestionId.style.padding = "20px";
      wrapper.appendChild(clonedQuestionId);
    } 
    wrapper.appendChild(clonedRefId);
    document.body.appendChild(wrapper);
    html2canvas(wrapper).then((canvas) => {
      document.body.removeChild(wrapper); // Clean up after capture
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 250;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save("download.pdf");
    });
    handleClose("download");
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    // event.preventDefault();
    callLogEvent("CLICKED_ON_NEW_DAILOG_SHARE_BUTTON", "Clicked on Share icon for viewing sharing options for the message");
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (action: string) => {
    setAnchorEl(null);
    if (action.toUpperCase().trim().replaceAll(' ', '_') !== "SHARE") {
      callLogEvent("CLICKED_ON_NEW_DAILOG_SHARE_" + action.toUpperCase().trim().replaceAll(' ', '_') + "_BUTTON", "Clicked on " + action.toUpperCase().trim().replaceAll(' ', '_') + " icon from sharing options for the message");
    }
  };

  const handleClick1 = (event: React.MouseEvent<HTMLElement>) => {
    // event.preventDefault();
    setAnchorEl2(event.currentTarget);
    callLogEvent("CLICKED_ON_NEW_DAILOG_VISUALIZE_BUTTON", "Clicked on visualize icon for showing visualization options");
  };
  const handleClose1 = (action: string) => {
    setAnchorEl2(null);
    if (action.toUpperCase().trim().replaceAll(' ', '_') !== "VISUALIZE") {
      callLogEvent("CLICKED_ON_NEW_DAILOG_VISUALIZE_" + action.toUpperCase().trim().replaceAll(' ', '_') + "_BUTTON", "Clicked on " + action.toUpperCase().trim().replaceAll(' ', '_') + " icon from visualization options")
    }
  };

  const handleSave = () => {
    handleSavedChats()
    callLogEvent("CLICKED_ON_NEW_DAILOG_SAVE_BUTTON", "Clicked on Save icon for saving the message")
  };


  return (
    <div className={styles.btnOptions}>
      <button disabled={false} onClick={handleClick}>
        <Tooltip title="Share" placement="top"><img src={share_icon} alt="share" /></Tooltip>
      </button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose("share")}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box display="flex" >
          <Tooltip title="Share via Email" placement="top"><MenuItem onClick={() => handleClose("email")}><img src={mail_icon} alt="mail" /></MenuItem></Tooltip>
          <Tooltip title="Download the chat" placement="top"><MenuItem onClick={handlePrint}><img src={download_icon} alt="download" /></MenuItem></Tooltip>
          <Tooltip title="Share via Teams" placement="top"><MenuItem onClick={() => handleClose("teams")}><img src={teams_icon} alt="teams" style={{ maxHeight: "16px", maxWidth: "16px" }} /></MenuItem></Tooltip>
          <Tooltip title="Copy message" placement="top"><MenuItem onClick={() => handleClose("copy")}><img src={copy_icon} alt="copy" style={{ maxHeight: "16px", maxWidth: "16px" }} /></MenuItem></Tooltip>
        </Box>
      </Menu>
      <button disabled={false} onClick={handleSave}>
        {msg.is_saved ? <Tooltip title="Saved Message" placement="top"><StarIcon style={{ maxHeight: "16px", maxWidth: "16px", color: "#005CBC" }} /></Tooltip> : <Tooltip title="Save Message" placement="top"><StarBorderIcon style={{ maxHeight: "16px", maxWidth: "16px", color: "#005CBC" }} /></Tooltip>}
      </button>
      <button onClick={handleClick1} hidden={msg.sender === "summary"}>
      <Tooltip title="Visualize" placement="top"><img src={visual_icon} alt="visual" /></Tooltip>
      </button>
      <Menu
        anchorEl={anchorEl2}
        open={Boolean(anchorEl2)}
        onClose={() => handleClose1("visualize")}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: isMobile ? 'center' : 'left',
        }}
      >
        <Box display="flex" style={{ marginLeft: "2px", minWidth: "auto" }}
          sx={{
            flexDirection: isMobile ? 'column' : 'row',
          }}>
          <Tooltip title="Auto Visualize" placement="top"><MenuItem onClick={() => {
            handleVisualization("Please generate the best visualization for the above data");
            handleClose1("auto visulaize");
          }}
            className={styles.menugrid}>
            <img src={auto_visualize} style={{ maxHeight: "16px", maxWidth: "16px", marginRight: "5px" }} alt="auto_visualize" />
            Auto Visualise</MenuItem></Tooltip>
            <Tooltip title="Visulaize using Bar Chart" placement="top"><MenuItem onClick={() => {
            handleVisualization("Visualize as a bar chart");
            handleClose1("Bar chart");
          }}
            className={styles.menugrid}>
            <img src={bar_chart} style={{ maxHeight: "16px", maxWidth: "16px", marginRight: "5px" }} alt="bar_chart" />
            Bar Chart</MenuItem></Tooltip>
            <Tooltip title="Visulaize using Pie Chart" placement="top"><MenuItem onClick={() => {
            handleVisualization("Visualize as a Pie chart");
            handleClose1("Pie chart");
          }}
            className={styles.menugrid}>
            <img src={pie_chart} style={{ maxHeight: "16px", maxWidth: "16px", marginRight: "5px" }} alt="pie_chart" />
            Pie Chart</MenuItem></Tooltip>
          <Tooltip title="Visulaize using Line Chart" placement="top"><MenuItem onClick={() => {
            handleVisualization("Visualize as a Line chart");
            handleClose1("Line chart");
          }}
            className={styles.menugrid}>
            <img src={line_chart} style={{ maxHeight: "16px", maxWidth: "16px", marginRight: "5px" }} alt="line_chart" />
            Line Chart</MenuItem></Tooltip>
        </Box>
      </Menu>

      {(msg?.agent_metadata && msg?.agent_metadata.length) ? <SqlDrawer msg={msg} /> : ""}
    </div>
  );
};

export default AdditionalOptions;
